(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5820],{

/***/ 40696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HospitalExcessToggleForTest */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14890);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36456);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _actions_customer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91395);
/* harmony import */ var _utils_hospital_excess_to_options__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31063);
/* harmony import */ var _selectors_select_customer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34112);
/* harmony import */ var _selectors_select_excess_toggle_values_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58400);









var HospitalExcessToggle = function(param) {
    var actions = param.actions, customerExcess = param.customerExcess, hospitalExcess = param.hospitalExcess, isRequired = param.isRequired;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
        hasContainerID: true,
        inputVariant: [
            "button"
        ],
        isRequired: isRequired,
        name: "Hospital excess change",
        onChange: actions.customer.changeHospitalExcess,
        options: (0,_utils_hospital_excess_to_options__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(hospitalExcess),
        size: "auto",
        type: "radioGroup",
        value: customerExcess
    });
};
HospitalExcessToggle.defaultProps = {
    isRequired: false
};
var mapStateToProps = function(state) {
    return {
        customerExcess: (0,_selectors_select_customer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(state).hospitalExcess,
        hospitalExcess: (0,_selectors_select_excess_toggle_values_index__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(state)
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            customer: (0,redux__WEBPACK_IMPORTED_MODULE_8__/* .bindActionCreators */ .DE)(_actions_customer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, dispatch)
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(HospitalExcessToggle));



/***/ }),

/***/ 78558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97189);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_4__);





// @ts-expect-error - Automatic, Please fix when editing this file
var LegacyBorderedWrapper = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? null : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Wrapper */ .im, {
        size: "extraExtraLarge",
        isFullWidth: true,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().withBorders), className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LegacyBorderedWrapper);


/***/ }),

/***/ 73230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fv": function() { return /* reexport */ MODAL_ID; },
  "ZP": function() { return /* binding */ components_modal; }
});

// UNUSED EXPORTS: ModalForTest, mapStateToProps

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/client/components/modal/constants.ts
// eslint-disable-next-line import/prefer-default-export
var MODAL_ID = {
    ADULT_DEPENDANT_AGE_ERROR: "adult-dependant-age-error",
    ADULT_DEPENDANT_SCALE_UNAVAILABLE_ERROR: "adult-dependant-scale-unavailable-error",
    AGR: "agr",
    COMPLEMENTARY_PRODUCT: "complementary-product",
    COPAYMENT_SELECT: "copayment-select",
    DECLARATION: "declaration",
    DEMO_STANDARD: "demo-standard",
    PREMIUM_CHANGE: "premium-change",
    SAVER_WARNING: "saver-warning",
    SEGMENTATION: "segmentation",
    SERVICE_DETAILS: "service-details"
};

// EXTERNAL MODULE: ./src/client/components/animate/index.tsx
var animate = __webpack_require__(1743);
// EXTERNAL MODULE: ./src/client/utils/browser.ts
var browser = __webpack_require__(40055);
// EXTERNAL MODULE: ./src/client/actions/modal/index.ts
var modal = __webpack_require__(18826);
// EXTERNAL MODULE: ./src/client/components/modal/styles.module.sass
var styles_module = __webpack_require__(80326);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/components/modal/index.tsx
/* eslint-disable jsx-a11y/click-events-have-key-events */ 














// @ts-expect-error - Automatic, Please fix when editing this file
var stopEventPropagation = function(event) {
    event.stopPropagation();
};
var Modal = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Modal, Component);
    var _super = (0,_create_super/* default */.Z)(Modal);
    function Modal() {
        (0,_class_call_check/* default */.Z)(this, Modal);
        var _this;
        _this = _super.apply(this, arguments);
        _this.addKeyEventListener = function() {
            browser/* default.getWindow */.Z.getWindow().addEventListener("keyup", _this.handleKeyEvent);
        };
        // @ts-expect-error - Automatic, Please fix when editing this file
        _this.handleKeyEvent = function(event) {
            var _props = _this.props, dispatch = _props.dispatch, id = _props.id;
            var ESC = 27;
            // If escape key is pressed then hide modal
            if (event.keyCode === ESC) {
                dispatch(modal/* default.closeModal */.Z.closeModal(id));
            }
        };
        _this.removeKeyEventListener = function() {
            browser/* default.getWindow */.Z.getWindow().removeEventListener("keyup", _this.handleKeyEvent);
        };
        _this.hide = function() {
            var _props = _this.props, dispatch = _props.dispatch, id = _props.id;
            dispatch(modal/* default.closeModal */.Z.closeModal(id));
        };
        // @ts-expect-error - Automatic, Please fix when editing this file
        _this.setHideOnMouseUp = function(param) {
            var target = param.target;
            target.addEventListener("click", _this.hide, {
                once: true
            });
        };
        return _this;
    }
    var _proto = Modal.prototype;
    /* eslint-disable-next-line react/sort-comp */ // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.UNSAFE_componentWillUpdate = function UNSAFE_componentWillUpdate(nextProps) {
        var body = browser/* default.getDocument */.Z.getDocument().body;
        var offset;
        var _props = this.props, beforeClose = _props.beforeClose, beforeOpen = _props.beforeOpen, visible = _props.visible;
        // Modal is opening
        if (!visible && nextProps.visible) {
            if ((0,fp.isFunction)(beforeOpen)) {
                beforeOpen();
            }
            // @ts-expect-error - Automatic, Please fix when editing this file
            offset = body.scrollTop;
            // @ts-expect-error - Automatic, Please fix when editing this file
            body.style.top = "".concat(offset * -1, "px");
            // @ts-expect-error - Automatic, Please fix when editing this file
            body.classList.add((styles_module_default()).disableBody);
        }
        // Modal is closing
        if (visible && !nextProps.visible) {
            if ((0,fp.isFunction)(beforeClose)) {
                beforeClose();
            }
            // Wait for animation to complete before removing
            setTimeout(function() {
                // @ts-expect-error - Automatic, Please fix when editing this file
                offset = parseInt(body.style.top, 10);
                // @ts-expect-error - Automatic, Please fix when editing this file
                body.classList.remove((styles_module_default()).disableBody);
                // @ts-expect-error - Automatic, Please fix when editing this file
                body.scrollTop = offset * -1;
            }, 700);
        }
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _props = this.props, afterClose = _props.afterClose, afterOpen = _props.afterOpen, visible = _props.visible;
        if (!prevProps.visible && visible) {
            if ((0,fp.isFunction)(afterOpen)) {
                afterOpen();
            }
            this.addKeyEventListener();
        }
        if (prevProps.visible && !visible) {
            this.removeKeyEventListener();
            if ((0,fp.isFunction)(afterClose)) {
                afterClose();
            }
        }
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.componentWillUnmount = function componentWillUnmount() {
        var body = browser/* default.getDocument */.Z.getDocument().body;
        // @ts-expect-error - Automatic, Please fix when editing this file
        body.classList.remove((styles_module_default()).disableBody);
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.render = function render() {
        var _props = this.props, bodyElementId = _props.bodyElementId, children = _props.children, displayCloseCross = _props.displayCloseCross, footer = _props.footer, header = _props.header, theme = _props.theme, variant = _props.variant, visible = _props.visible;
        // @ts-expect-error - Automatic, Please fix when editing this file
        var closeClassName = classnames_default()((styles_module_default()).close, (0,_define_property/* default */.Z)({}, (styles_module_default()).closeDarkGrey, header));
        // @ts-expect-error - Automatic, Please fix when editing this file
        var contentClassName = classnames_default()((styles_module_default()).content, (0,_define_property/* default */.Z)({}, (styles_module_default())[theme], theme));
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: ahm_ui/* variants.getStyle */.oW.getStyle(variant, (styles_module_default())),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* default */.Z, {
                    name: "overlayFade",
                    children: visible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).overlay,
                        onClick: this.hide
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* default */.Z, {
                    name: "modalSlideIn",
                    children: visible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).wrapper,
                        onMouseDown: this.setHideOnMouseUp,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).modal,
                            onClick: stopEventPropagation,
                            onMouseDown: stopEventPropagation,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: contentClassName,
                                children: [
                                    displayCloseCross && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: closeClassName,
                                        onClick: this.hide,
                                        children: "\xd7"
                                    }),
                                    header && /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                        className: (styles_module_default()).header,
                                        children: header
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).body,
                                        id: bodyElementId,
                                        children: children
                                    }),
                                    footer && /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                                        className: (styles_module_default()).footer,
                                        children: footer
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        });
    };
    return Modal;
}(react.Component);
// @ts-expect-error - Automatic, Please fix when editing this file
Modal.defaultProps = {
    afterClose: fp.noop,
    afterOpen: fp.noop,
    beforeClose: fp.noop,
    beforeOpen: fp.noop,
    bodyElementId: undefined,
    children: undefined,
    displayCloseCross: false,
    footer: undefined,
    header: undefined,
    theme: undefined,
    variant: undefined
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapStateToProps = function(state, ownProps) {
    return {
        visible: state.modal.visible === ownProps.id
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
/* harmony default export */ var components_modal = ((0,es/* connect */.$j)(mapStateToProps)(Modal));



/***/ }),

/***/ 30510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_get_offer_presale_details; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/offers/lib/model/offer/get-eligible-rewards/index.js
var get_eligible_rewards = __webpack_require__(14282);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/offers/lib/model/offer/get-upsell-applicable-rewards/index.js
var get_upsell_applicable_rewards = __webpack_require__(80336);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/offers/lib/model/offer/is-eligible/index.js
var is_eligible = __webpack_require__(40932);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/constants/lib/src/index.js
var src = __webpack_require__(13294);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/content/offers/qualified/get-presale-sentence/index.js
var get_presale_sentence = __webpack_require__(96276);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/offers/lib/model/offer/get-restricted-upsell-rewards/index.js
var get_restricted_upsell_rewards = __webpack_require__(49897);
// EXTERNAL MODULE: ./src/client/components/offers/logic/get-is-every-upsell-reward-restricted/index.ts
var get_is_every_upsell_reward_restricted = __webpack_require__(93643);
;// CONCATENATED MODULE: ./src/client/components/offers/callout/utils/generate-presale-sentence/index.ts



// @ts-expect-error - Automatic, Please fix when editing this file


// @ts-expect-error - Automatic, Please fix when editing this file

// @ts-expect-error - Automatic, Please fix when editing this file


var _obj;
var PRODUCT_TYPE_TO_UPSELL_TYPE_MAP = (_obj = {}, (0,_define_property/* default */.Z)(_obj, src.PRODUCT_TYPE.EXTRAS, get_presale_sentence/* UPSELL_TYPE.HOSPITAL */.ky.HOSPITAL), (0,_define_property/* default */.Z)(_obj, src.PRODUCT_TYPE.HOSPITAL, get_presale_sentence/* UPSELL_TYPE.EXTRAS */.ky.EXTRAS), _obj);
// @ts-expect-error - Automatic, Please fix when editing this file
var getEligibleSentence = function(offer, scenario) {
    var eligibleRewards = (0,get_eligible_rewards["default"])(offer, scenario);
    if ((0,fp.isEmpty)(eligibleRewards)) {
        return null;
    }
    // @ts-expect-error - Automatic, Please fix when editing this file
    return (0,get_presale_sentence/* default */.ZP)({
        offer: offer,
        rewards: eligibleRewards
    });
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getUpsellSentence = function(offer, scenario, product) {
    var upsellApplicableRewards = (0,get_upsell_applicable_rewards/* default */.Z)(offer, scenario);
    if ((0,fp.isEmpty)(upsellApplicableRewards)) {
        return null;
    }
    var productType = product === null || product === void 0 ? void 0 : product.type;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ extras: string; hospital: string; }'.
    var upsellType = PRODUCT_TYPE_TO_UPSELL_TYPE_MAP[productType];
    if (!upsellType) {
        return null;
    }
    var restrictedUpsellRewards = (0,get_restricted_upsell_rewards/* default */.Z)(offer, scenario);
    var isEveryRewardRestricted = (0,get_is_every_upsell_reward_restricted/* default */.Z)({
        restrictedUpsellRewards: restrictedUpsellRewards,
        upsellApplicableRewards: upsellApplicableRewards
    });
    return (0,get_presale_sentence/* default */.ZP)({
        isRestricted: isEveryRewardRestricted,
        offer: offer,
        rewards: upsellApplicableRewards,
        upsell: upsellType
    });
};
// @ts-expect-error - Automatic, Please fix when editing this file
var generatePresaleSentence = function(offer) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, product = ref.product, scale = ref.scale;
    var productId = product === null || product === void 0 ? void 0 : product.id;
    var scenario = {
        productId: productId,
        scale: scale
    };
    return getEligibleSentence(offer, scenario) || getUpsellSentence(offer, scenario, product);
};
/* harmony default export */ var generate_presale_sentence = (generatePresaleSentence);

// EXTERNAL MODULE: ./src/client/components/offers/logic/use-get-active-promo-offer/index.ts
var use_get_active_promo_offer = __webpack_require__(8235);
;// CONCATENATED MODULE: ./src/client/components/offers/callout/use-get-offer-presale-details/index.ts



// @ts-expect-error - Automatic, Please fix when editing this file

// @ts-expect-error - Automatic, Please fix when editing this file

// @ts-expect-error - Automatic, Please fix when editing this file



var useGetOfferPresaleDetails = function(param) {
    var referrerAttribution = param.referrerAttribution, scenario = param.scenario, targetSegment = param.targetSegment;
    var ref;
    var ref1 = (0,use_get_active_promo_offer/* default */.Z)({
        // @ts-expect-error - Automatic, Please fix when editing this file
        referrerAttribution: referrerAttribution,
        targetSegment: targetSegment
    }), offers = ref1.activeOffers;
    if ((0,fp.isNull)(offers)) {
        return null;
    }
    var scenarioForRewardEligibility = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, scenario), {
        productId: scenario === null || scenario === void 0 ? void 0 : (ref = scenario.product) === null || ref === void 0 ? void 0 : ref.id
    });
    var getRewards = function(offer) {
        var eligibleRewards = (0,get_eligible_rewards["default"])(offer, scenarioForRewardEligibility);
        var upsellApplicableRewards = (0,get_upsell_applicable_rewards/* default */.Z)(offer, scenarioForRewardEligibility);
        return (0,fp.isEmpty)(eligibleRewards) ? upsellApplicableRewards : eligibleRewards;
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    var offersWithPresaleDetails = (0,fp.map)(function(offer) {
        return {
            offer: offer,
            presaleSentence: generate_presale_sentence(offer, scenario),
            rewards: getRewards(offer)
        };
    })(offers);
    var eligibleOffers = (0,fp.filter)(function(param) {
        var offer = param.offer;
        return (0,is_eligible/* default */.Z)(offer, scenarioForRewardEligibility);
    })(offersWithPresaleDetails);
    var filteredOffer = (0,fp.isEmpty)(eligibleOffers) ? (0,fp.last)((0,fp.filter)(function(param) {
        var rewards = param.rewards;
        return !(0,fp.isEmpty)(rewards);
    })(offersWithPresaleDetails)) : (0,fp.last)(eligibleOffers);
    if (!filteredOffer) {
        return null;
    }
    return filteredOffer;
};
/* harmony default export */ var use_get_offer_presale_details = (useGetOfferPresaleDetails);


/***/ }),

/***/ 93643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96852);


// @ts-expect-error - Automatic, Please fix when editing this file
var getIsEveryUpsellRewardRestricted = function(param) {
    var upsellApplicableRewards = param.upsellApplicableRewards, restrictedUpsellRewards = param.restrictedUpsellRewards;
    var isEveryRewardRestricted = (0,_utils_uncap_fp_iterator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(lodash_fp__WEBPACK_IMPORTED_MODULE_0__.every)(// @ts-expect-error - Automatic, Please fix when editing this file
    function(rewardIds, offerTypeId) {
        return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.every)(function(rewardId) {
            return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(rewardId, restrictedUpsellRewards === null || restrictedUpsellRewards === void 0 ? void 0 : restrictedUpsellRewards[offerTypeId]);
        }, rewardIds);
    }, upsellApplicableRewards);
    return isEveryRewardRestricted;
};
/* harmony default export */ __webpack_exports__["Z"] = (getIsEveryUpsellRewardRestricted);


/***/ }),

/***/ 44001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40055);

var clearFormData = function(name) {
    return _browser__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getWindow */ .Z.getWindow().sessionStorage.removeItem(name);
};
/* harmony default export */ __webpack_exports__["Z"] = (clearFormData);


/***/ }),

/***/ 31063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

var hospitalExcessToOptions = function(hospitalExcess) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(value) {
        return {
            text: "$".concat(value),
            value: "".concat(value)
        };
    }, hospitalExcess);
};
/* harmony default export */ __webpack_exports__["Z"] = (hospitalExcessToOptions);


/***/ }),

/***/ 69076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ GrowthBookPageWrapper; }
/* harmony export */ });
/* unused harmony exports generateGrowthBookSSRProps, injectGrowthBookProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _growthbook_growthbook_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _src_client_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75624);









// @ts-expect-error - Automatic, Please fix when editing this file
var generateGrowthBookSSRProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var req, resolvedUrl, gbClientId, host;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            req = param.req, resolvedUrl = param.resolvedUrl;
            gbClientId = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("cookies.gbClientId")(req);
            host = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("headers.host")(req);
            return [
                2,
                (0,_growthbook_growthbook_react__WEBPACK_IMPORTED_MODULE_2__/* .getGrowthBookSSRData */ .R$)({
                    apiHost: _src_client_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("growthbook:apiHost"),
                    attributes: {
                        id: gbClientId || "",
                        url: "".concat(host).concat(resolvedUrl)
                    },
                    clientKey: _src_client_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("growthbook:clientKey")
                })
            ];
        });
    });
    return function generateGrowthBookSSRProps(_) {
        return _ref.apply(this, arguments);
    };
}();
// @ts-expect-error - Automatic, Please fix when editing this file
var injectGrowthBookProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var context, props, growthBookData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    context = param.context, props = param.props;
                    return [
                        4,
                        generateGrowthBookSSRProps(context)
                    ];
                case 1:
                    growthBookData = _state.sent();
                    return [
                        2,
                        {
                            props: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.set)("growthBookData", growthBookData, props)
                        }
                    ];
            }
        });
    });
    return function injectGrowthBookProps(_) {
        return _ref.apply(this, arguments);
    };
}();
var GrowthBookPageWrapper = function(props, Component) {
    var growthBookData = props.growthBookData, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props, [
        "growthBookData"
    ]);
    // This is required once at the top of the SSR page
    (0,_growthbook_growthbook_react__WEBPACK_IMPORTED_MODULE_2__/* .useGrowthBookSSR */ .jL)(growthBookData);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rest));
};


/***/ }),

/***/ 63674:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","text":"text_text__pmfDl","light":"text_light__Ml3pC","lowercase":"text_lowercase__Yl2Hy","greyText50":"text_greyText50__BdYuX"};

/***/ }),

/***/ 84366:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"theme_black__rW4ak","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"theme_grey10__TFw6A","grey20":"theme_grey20__7rmAc","grey30":"theme_grey30__LogO6","grey40":"#888","grey50":"#666","grey60":"theme_grey60__nrD9l","grey70":"theme_grey70__lib7h","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"theme_white__ytr9x","zIndexFooter":"700","transparent":"theme_transparent__KJtEW","transparentBlackText":"theme_transparentBlackText__htgxS"};

/***/ }),

/***/ 97189:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","withBorders":"styles_withBorders__jpuBF"};

/***/ }),

/***/ 80326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","disableBody":"styles_disableBody__jbtgW","overlay":"styles_overlay__1jd6E","wrapper":"styles_wrapper__uSaLt","modal":"styles_modal__r1b9D","content":"styles_content__HL_oM","close":"styles_close__Hhmkl","closeDarkGrey":"styles_closeDarkGrey__Zv_FT","grey":"styles_grey__KyYyB","header":"styles_header__eAmz7","body":"styles_body__EWdZg","footer":"styles_footer__JTwvp","premiumChange":"styles_premiumChange__6uUKX","withoutCloseCross":"styles_withoutCloseCross__Hwo24"};

/***/ })

}]);